import React from 'react';
import { Form } from 'react-bootstrap';
import { FormSelect } from '~/components/FormControl';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import isEmpty from 'lodash/isEmpty';

function CardTransformedDetail() {
    const { cardMetaData } = useFormTab();
    const { actions, upgrades } = cardMetaData;

    return (
        <Form.Row>
            {!isEmpty(cardMetaData) && (
                <>
                    <FormSelect
                        name="cardTransformedDetail.playerTransformedActionOrUpgradeCard"
                        options={[...actions, ...upgrades] || []}
                        sm={4}
                        tooltip="Transform a player's current played Action/Upgrade card"
                    />
                    <FormSelect
                        name="cardTransformedDetail.opponentTransformedActionOrUpgradeCard"
                        options={[...actions, ...upgrades] || []}
                        sm={4}
                        tooltip="Transform a opponent's current played Action/Upgrade card"
                    />
                    <FormSelect
                        name="cardTransformedDetail.inDeckTransformedCard"
                        options={[...actions, ...upgrades] || []}
                        sm={4}
                        tooltip="Transform a player's card in current deck"
                    />
                </>
            )}
        </Form.Row>
    );
}

export default CardTransformedDetail;
